import script from "./SolarSystem.vue?vue&type=script&setup=true&lang=js"
export * from "./SolarSystem.vue?vue&type=script&setup=true&lang=js"

import "./SolarSystem.vue?vue&type=style&index=0&id=4bc695f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc695f2"]])

export default __exports__